module.exports = __webpack_public_path__ + "img/b62479acd42d7c734c36a036a5d01ab4.71164fc6.png";